
import {
  Component, Emit, Prop, Vue,
} from 'nuxt-property-decorator'
import BaseLink from '../base/BaseLink.vue'
import type { TGptRole } from '../../shared/general/types/GptHub'

@Component({
  name: 'GptMessage',
  components: {
    BaseLink,
  },
})
export default class GptMessage extends Vue {
  @Prop({ required: true }) role! : TGptRole

  @Prop({ required: true }) content! : string

  @Prop({ default: false }) failed! : boolean

  @Emit('resend')
  private resend () : void {}
}
